var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "about-layout__loyalty_partners" },
        [
          _c(
            "transition-group",
            { attrs: { name: "fade" } },
            _vm._l(_vm.banks, function(bank) {
              return _c("div", { key: bank.title, staticClass: "item" }, [
                _c("div", { staticClass: "item__img" }, [
                  _c("img", { attrs: { src: bank.logo, alt: "" } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item__head" }, [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(bank.title))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("a", { attrs: { href: "tel:" + bank.phone.digits } }, [
                      _vm._v(_vm._s(bank.phone.title))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "bank-link",
                        attrs: {
                          href: bank.website.url,
                          rel: "nofollow",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(bank.website.title))]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item__desc" }, [
                  _c("p", { domProps: { innerHTML: _vm._s(bank.text) } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item__percent" }, [
                  _c("span", [_vm._v(_vm._s(bank.percent) + "%")])
                ])
              ])
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", duration: 350 } }, [
        _c(
          "footer",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.banks.length < _vm.total,
                expression: "banks.length < total"
              }
            ],
            staticClass: "about-layout__loyalty_foot"
          },
          [
            _c(
              "button",
              {
                staticClass: "button-pill lighted",
                class: { loading: _vm.isLoading },
                on: {
                  click: function($event) {
                    return _vm.getBanks()
                  }
                }
              },
              [_vm._v("Загрузить ещё")]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }